var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1021_12247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 2.50057C18.3683 3.06347 17.4848 3.49399 16.5497 3.77557C16.0478 3.19849 15.3808 2.78948 14.6389 2.60384C13.897 2.4182 13.1159 2.4649 12.4014 2.73761C11.6869 3.01033 11.0734 3.4959 10.6438 4.12866C10.2143 4.76143 9.98942 5.51085 9.99967 6.27557V7.1089C8.5352 7.14687 7.08407 6.82208 5.77552 6.16344C4.46696 5.5048 3.34161 4.53276 2.49967 3.3339C2.49967 3.3339 -0.833659 10.8339 6.66634 14.1672C4.95011 15.3322 2.90564 15.9163 0.833008 15.8339C8.33301 20.0006 17.4997 15.8339 17.4997 6.25057C17.4989 6.01845 17.4766 5.7869 17.433 5.5589C18.2835 4.72015 18.8837 3.66116 19.1663 2.50057Z",
    fill: "#9CAEC0",
    stroke: "#9CAEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1021_12247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.395ae86625aaedbfd03a9fe3a01f4aa5.svg";
export { ForwardRef as ReactComponent };